var _excluded = ["className", "disabled", "loading", "type", "size", "variant", "fullWidth", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { AgroSpinner } from '../AgroSpinner';
import { MDButton, SMButton, LGButton, XLButton } from './StyledButton';
var sizes = {
  sm: SMButton,
  md: MDButton,
  lg: LGButton,
  xl: XLButton
};
var AgroButton = withCssProps(function (_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var Button = sizes[size];
  var getLoaderColor = function getLoaderColor() {
    var colors = {
      primary: 'white',
      secondary: 'primary',
      landingPrimary: 'white',
      landingSecondary: 'white',
      outlinePrimary: 'primary',
      outlineSecondary: 'gray',
      danger: 'white',
      text: 'primary'
    };
    return colors[variant];
  };
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: className,
    variant: variant,
    isLoading: loading,
    disabled: disabled,
    fullWidth: fullWidth,
    type: type,
    as: "button",
    "data-cy": "button"
  }, props), loading ? /*#__PURE__*/React.createElement(AgroSpinner, {
    size: "16px",
    variant: getLoaderColor()
  }) : children);
});
AgroButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  children: PropTypes.node,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'outlinePrimary', 'outlineSecondary', 'danger', 'landingPrimary', 'landingSecondary', 'text']),
  fullWidth: PropTypes.bool
};
AgroButton.displayName = 'AgroButton';
export { AgroButton };